import gql from 'graphql-tag'

export const deviceCancelConfiguration = gql`
  mutation deviceCancelConfiguration($deviceId: ID!) {
    deviceCancelConfiguration(input: { deviceId: $deviceId }) {
      success
    }
  }
`
